import { render, staticRenderFns } from "./InputRegisterCode.vue?vue&type=template&id=240da1d8&scoped=true&"
import script from "./InputRegisterCode.vue?vue&type=script&lang=ts&"
export * from "./InputRegisterCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240da1d8",
  null
  
)

export default component.exports